// @archigraph r8DljQiU
import { Outlet } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';

export function Layout() {
  return (
    <div className="flex flex-col min-h-screen bg-bg text-text">
      <Header />
      <main className="flex-1 pt-14" id="main-content">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
